import { render, staticRenderFns } from "./chooseDeptOrPersonDialog.vue?vue&type=template&id=6a6fa612&scoped=true&"
import script from "./chooseDeptOrPersonDialog.vue?vue&type=script&lang=ts&"
export * from "./chooseDeptOrPersonDialog.vue?vue&type=script&lang=ts&"
import style0 from "./chooseDeptOrPersonDialog.vue?vue&type=style&index=0&id=6a6fa612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fa612",
  null
  
)

export default component.exports